module.exports = __webpack_public_path__ + "static/media/hot21.d00a62b0.jpg";